import { useEffect, useState } from 'react'

const STORAGE_KEY = 'wedding-pro-os-launch-deadline'
const WINDOW_MS = 24 * 60 * 60 * 1000

function getDeadline(): number {
  if (typeof window === 'undefined') return Date.now() + WINDOW_MS
  const stored = window.localStorage.getItem(STORAGE_KEY)
  if (stored) {
    const parsed = Number(stored)
    if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed
  }
  const next = Date.now() + WINDOW_MS
  window.localStorage.setItem(STORAGE_KEY, String(next))
  return next
}

function pad(value: number): string {
  return String(Math.max(0, value)).padStart(2, '0')
}

export function useCountdown() {
  const [deadline] = useState<number>(getDeadline)
  const [remaining, setRemaining] = useState<number>(() =>
    Math.max(0, deadline - Date.now()),
  )

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(Math.max(0, deadline - Date.now()))
    }, 1000)
    return () => window.clearInterval(id)
  }, [deadline])

  const totalSeconds = Math.floor(remaining / 1000)

  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
  }
}
